import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const accountingService = {
  getCapabilities,
  getXeroStatus,
  getXeroConnectUrl,
  activateXeroConnection,
  disconnectXero,
  getQuickbooksStatus,
  getQuickbooksConnectUrl,
  activateQuickbooksConnection,
  disconnectQuickbooks,
}

const API_URL = API.BASE_URL + '/v1'

/**
 * What the tenant's accounting system can do.
 *
 * Read-only. Which system a tenant runs is the `accounting_driver`
 * configuration row, changed on the configuration screen — so there is no
 * setter here on purpose.
 */
export function getCapabilities() {
  return apiHelper(API_URL).get('/accounting/capabilities')
}

/*
 * OAuth-connected ledgers (Xero, QuickBooks Online).
 *
 * Connect returns a consent URL the browser opens in a new tab; the callback
 * lands on the server, which stores the tokens. Status lists every stored
 * organisation; one is active at a time. Disconnect revokes at the provider.
 * All of these sit behind `Update Configuration`.
 */
export function getXeroStatus() {
  return apiHelper(API_URL).get('/xero/status')
}

export function getXeroConnectUrl() {
  return apiHelper(API_URL).get('/xero/connect')
}

export function activateXeroConnection(uuid) {
  return apiHelper(API_URL).post(`/xero/connections/${uuid}/activate`)
}

export function disconnectXero(uuid) {
  return apiHelper(API_URL).delete(`/xero/connections/${uuid}`)
}

export function getQuickbooksStatus() {
  return apiHelper(API_URL).get('/quickbooks/status')
}

export function getQuickbooksConnectUrl() {
  return apiHelper(API_URL).get('/quickbooks/connect')
}

export function activateQuickbooksConnection(uuid) {
  return apiHelper(API_URL).post(`/quickbooks/connections/${uuid}/activate`)
}

export function disconnectQuickbooks(uuid) {
  return apiHelper(API_URL).delete(`/quickbooks/connections/${uuid}`)
}
